import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  totalItems: number;
  itemPerRowDesktop: number;
  title: string;
  containerClassName?: string;
  listClassName: string;
  startFromEnd?: boolean;
  headerPadding?: boolean;
}

export const HorizontalSlider: React.FC<IProps> = ({
  totalItems,
  itemPerRowDesktop = 3,
  containerClassName = '',
  listClassName,
  title,
  startFromEnd = false,
  children,
  headerPadding = false,
}) => {
  const { t } = useTranslation();
  const [windowDimension, detectW] = useState({
    winWidth: 0,
  });
  const List = React.createRef<HTMLDivElement>();
  const detectSize = () => {
    detectW({
      winWidth: window.innerWidth,
    });
  };

  useEffect(() => {
    if (startFromEnd && List.current) {
      List.current.scrollLeft = List.current.scrollWidth;
    }
    detectSize();
  }, []);

  const calcXoffset = (): number => {
    if (!List.current) return 0;
    const elemWidth = List.current.scrollWidth / totalItems;
    if (windowDimension.winWidth < 992 && windowDimension.winWidth >= 600) {
      return List.current.scrollWidth / (totalItems / 2);
    } else if (windowDimension.winWidth < 600) {
      return List.current.scrollWidth / totalItems;
    } else {
      return elemWidth * itemPerRowDesktop;
    }
  };

  const scroll = (action: string) => {
    if (List.current) {
      switch (action) {
        case 'next':
          List.current.scrollLeft += calcXoffset();
          break;
        case 'prev':
          List.current.scrollLeft -= calcXoffset();
          break;

        default:
          return;
      }
    }

    return;
  };

  return (
    <>
      {totalItems > 0 && (
        <>
          <section className={containerClassName}>
            <div
              className={classNames('horizontal_slider__row_container', {
                'horizontal_slider__row_container--header_padding':
                  headerPadding,
              })}
            >
              <h2 className="horizontal_slider__row_container__title">
                {title}
              </h2>
              <>
                <ul className="horizontal_slider__row_container__controls">
                  <li className="horizontal_slider__row_container__controls__arrow">
                    <button
                      aria-label="previous elements"
                      className="horizontal_slider__row_container__controls__arrow--prev"
                      onClick={() => scroll('prev')}
                    >
                      <span>{t('prev')}</span>
                    </button>
                  </li>
                  <li className="horizontal_slider__row_container__controls__arrow">
                    <button
                      aria-label="next elements"
                      className="horizontal_slider__row_container__controls__arrow--next"
                      onClick={() => scroll('next')}
                    >
                      <span>{t('next')}</span>
                    </button>
                  </li>
                </ul>
              </>
            </div>
            <div
              className={listClassName}
              ref={List}
              style={{ scrollBehavior: 'smooth' }}
            >
              {children}
            </div>
          </section>
          <hr />
        </>
      )}
    </>
  );
};
